

export default function openFile(acceptFileType, onProcessOpenFile) {

    const handleChange = (e) => {
        if (onProcessOpenFile) {
            let file;
            if (e && e.target && e.target.files) {
                file = e.target.files[0];
            }
            onProcessOpenFile(file);
            if (e && e.target) {
                e.target.value = null;
            }
        }
    };

    let input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', acceptFileType);
    input.style.display = 'none';
    input.addEventListener('change', handleChange, false);
    document.body.appendChild(input);
    input.click();
    document.body.removeChild(input);
}
